import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'

export default {
    getList() {
        return axios.get('unauthenticated/states', {
            transformResponse: [OptionsTransformer.transform('code', 'name')],
        })
    },
}
